<template>
    <div>
        <div class="outTopBox">
            <top-bread :bread="bread">
                <span slot="second">广告管理</span>
                <span slot="third">订单管理</span>
            </top-bread>
            <fold-top-search @fold="getFoldMeth"></fold-top-search>
        </div>

        <el-card class="box-card searchCard" v-if="fold.showSearch">
            <top-search :topSearchShow="topSearchShow" @condition="getCondition"></top-search>
        </el-card>
        <el-card class="box-card">
            <table-list :table="table" @tableMeth="tableMeth" @page="getNewPage" @limit="getNewLimit" @tableSelect="getTableSelect" v-loading="table.loading"></table-list>
        </el-card>
    </div>
</template>

<script>
    import  qs from 'querystring'
    export default {
        name: "adManCustom",
        data: () => ({
            bread:{
                level:3,
                firstPath:{path: '/indexShow'},
                thirdPath:{path: '/hotelManAll'},
                fourthPath:{path: '/hotelManAll'},
            },
            table:{
                tableHeader:[
                    {prop:'order_no',label:'订单号',width:''},
                    {prop:'agent_company_name',label:'代理商',width:''},
                    {prop:'company_name',label:'客户',width:''},
                    {prop:'ad_start_time',label:'开始时间',width:''},
                    {prop:'ad_end_time',label:'结束时间',width:''},
                    {prop:'status_str',label:'订单状态',width:''},
                ],
                tableList:[],
                page:1,
                limit:5,   //当前每页显示多少条
                total:0,
                fromUrl:'adManOrder',
                option:true,
                select:true,
                loading:true
            },
            topSearchShow:{ },
            condition:{},
            operateIds:'',
            token:'',
            fold:{
                showSearch:false,
                foldText:'展开筛选项'
            },
            funArr:[],
            allData:{}
        }),
        methods:{
            confirmMeth(type,str){
                if(this.operateIds!==''){
                    this.$confirm('确定'+str+'？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        if(type==='start'){
                            this.operateMeth('start','启用');
                        }else if(type==='stop'){
                            this.operateMeth('stop','暂停');
                        }else if(type==='del'){
                            this.operateMeth('del','删除');
                        }
                    }).catch(() => {

                    });
                }else{
                    this.$message({
                        message: '请选择消息',
                        type: 'warning'
                    });
                }
            },
            startMeth(){

            },
            stopMeth(){

            },
            operateMeth(){
                var param='';
                var url='';
                var obj={};
                if(type==='start'){
                    url=this.global.infoDestory;
                    obj={
                        token:this.token,
                        ids:this.operateIds
                    };

                }else if(type==='stop'){
                    url=this.global.infoPublish;
                    obj={
                        token:this.token,
                        ids:this.operateIds
                    };
                }else if(type==='del'){
                    url=this.global.infoPublish;
                    obj={
                        token:this.token,
                        ids:this.operateIds
                    };
                }
                param=qs.stringify(obj);
                // this.$http.post(url,param).then(res=>{
                //     console.log('删除,发布',res);
                //     if(res.data.code===100000){
                //         this.$message.success(str+'成功');
                //         this.tableMeth();
                //     }else{
                //         this.$message.error(res.msg);
                //     }
                // }).catch(()=>{
                //     this.$message.error('返回错误');
                // })
            },
            newBuild(){
                this.$router.push({path:'/adManCusNew'})
            },
            tableMeth(orderVal){
                this.table.loading=true;
                var sortStr='';
                var orderStr='';
                if(orderVal){
                    if(orderVal.prop.indexOf('_text')!==-1){
                        var index=orderVal.prop.indexOf('_text');
                        sortStr=orderVal.prop.substring(0,index);
                    }else{
                        sortStr=orderVal.prop;
                    }
                    orderVal.order==='ascending'?orderStr='ASC':orderStr='DESC';
                }else{
                    sortStr='id';
                    orderStr='DESC';
                }
                this.$http.get(this.global.orderSearch,{
                    params:{
                        token:this.token,
                        page:this.table.page,
                        size:this.table.limit,
                        sort:sortStr,
                        order:orderStr,
                    }
                }).then(res=>{
                    if(res.data.code===100000){
                        var tableData=res.data.data;
                        this.table.tableList=tableData.items;
                        this.table.total=parseInt(tableData.total);
                    }else{
                        this.$message.warning(res.data.msg);
                    }
                    this.table.loading=false;
                }).catch(()=>{
                    this.table.loading=false;
                })
            },
            getNewPage(newPage){
                this.table.page=newPage;
                this.table.loading=true;
                this.tableMeth();
            },
            getNewLimit(newLimit){
                this.table.limit=newLimit;
                this.table.loading=true;
                this.tableMeth();
            },
            getTopSearchShow(){
                var auth=JSON.parse(sessionStorage.getItem('auth'));
                var auth_type=auth.type;
                if(auth_type==='channel' || auth_type==='screen' || auth_type==='group'  || auth_type==='factory'){
                    this.topSearchShow={
                        orderStatus:true,
                        keyword:true,
                    }
                }else if(auth_type==='htrip'){
                    this.topSearchShow={
                        orderStatus:true,
                        keyword:true,
                    }
                }
            },
            getCondition(val){
                this.condition.adStatus=Array.isArray(val.adStatus)?val.adStatus.join(','):''; //ka
                this.condition.adFormat=Array.isArray(val.adFormat)?val.adFormat.join(','):''; //ka
                this.condition.keyword=val.keyword; //ka
                this.tableMeth();
            },
            getTableSelect(val){
                var operateIds='';
                val.forEach((item,index)=>{
                    operateIds+=item.id+','
                });
                this.operateIds=operateIds.slice(0,-1);
            },
            getFoldMeth(val){
                this.fold=val;
            },
            getGroupLevel(){
                return new Promise((resolve,reject)=>{
                    this.$http.get(this.global.groupLevel,{
                        params:{
                            token:this.token
                        }
                    }).then(res=>{
                        if(res.data.code===100000){
                            this.curId=res.data.data.pid[0];
                        }
                        resolve(res.data.data.pid[0]);
                    });
                })
            },
            getTreeData(pid){
                var param=qs.stringify({
                    token:this.token,
                    pid:pid,
                });
                this.$http.post(this.global.roletree,param).then(res=>{
                    if(res.data.code===100000){
                        this.allData=res.data.data;
                        this.allData.forEach((item,index)=>{
                            var menuId=sessionStorage.getItem('defaultActiveId');
                            if(item.parent==menuId){
                                this.funArr.push(item.text);
                            }
                        });
                        this.showFunModelCondition();
                    }
                });
            },
            showFunModelCondition(){
                this.funArr.indexOf('详情')!==-1
                    ? this.table.option=true
                    : this.table.option=false
            }

        },
        mounted(){
            this.token=sessionStorage.getItem('token');
            this.getTopSearchShow();
            this.tableMeth();
            this.getGroupLevel().then(res=>{
                this.getTreeData(res);
            });
        },
        computed:{
            showFunModel(){
                return function(val){
                    if(this.funArr.indexOf(val)!==-1){
                        return true;
                    }else{
                        return false;
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .rightBtn{
        margin-left:auto;
    }

</style>
